import loading from 'cignacmb-vue-components-mobile/src/popup-instances/full-screen-loading.js';

const MIN_DURATION = 500; // 毫秒为单位的显示最小时间, 避免闪烁
let count = 0;
let openedTime = 0;
let timer = -1;

const queue = [];

const open = function (queuer) {
    if (count === 0) {
        openedTime = Date.now();
    }

    queue.push(queuer);
    count++;
    clearTimeout(timer);
    loading.open({
        message: ""
    });
};

const close = function () {
    count--;

    if (count === 0) {
        const duration = Date.now() - openedTime;
        const complete = function () {
            loading.close();
            // loading关闭后, 再去修改包装的promise对象的状态, 因为有的请求结束后可能弹窗, 避免loading还在显示的时候出现弹窗
            let queuer = queue.pop();

            while(queuer) {
                const {
                    promise,
                    resolve,
                    reject
                } = queuer;

                promise.then(resolve, reject);

                queuer = queue.pop();
            }
        };

        if (duration < MIN_DURATION) {
            timer = setTimeout(function () {
                complete();
            }, MIN_DURATION - duration);
        } else {
            complete();
        }
    }
};

export default function (promise) {
    if (typeof promise.then === 'function') {
        // 包装返回一个新的promise对象, 回调时控制关闭loading
        return new Promise(function (resolve, reject) {
            promise.then(close, close);
            open({ promise, resolve, reject});
        });
    }

    return promise;
}
